import { APP_VERSION } from "@secret-cabinet/contracts";
import { LogOut, Wifi, WifiOff } from "lucide-react";
import type { ConnectionStatus } from "../use-room-socket";
import { AudioControl } from "./AudioControl";
import { Brand } from "./Brand";

export function RoomHeader({
  code,
  status,
  tv = false,
  tvAudio,
  onTvClose,
  onLeave,
}: {
  code: string;
  status: ConnectionStatus;
  tv?: boolean;
  tvAudio?: { muted: boolean; onToggle: () => void };
  onTvClose?: () => void;
  onLeave?: () => void;
}) {
  if (tv) {
    return (
      <header className="room-header room-header--tv shared-tv-header">
        <div className="shared-tv-brand"><Brand compact markOnly /></div>
        <div className="shared-tv-context"><span>ROOM CODE</span><strong>{code}</strong></div>
        <div className="shared-tv-actions">
          {tvAudio ? <AudioControl muted={tvAudio.muted} onToggle={tvAudio.onToggle} /> : null}
          <button className="tv-close-button" type="button" aria-label="Close TV" onClick={onTvClose}>
            <LogOut aria-hidden="true" />
          </button>
        </div>
      </header>
    );
  }
  return (
    <header className="room-header">
      <Brand compact />
      <div className="room-header__meta">
        <span className="room-code"><small>Room</small> {code}</span>
        <span className="app-version" aria-label={`Secret Cabinet version ${APP_VERSION}`}>
          v{APP_VERSION}
        </span>
        <span className={`connection connection--${status}`}>
          {status === "live" ? <Wifi aria-hidden="true" /> : <WifiOff aria-hidden="true" />}
          {status === "live" ? "Live" : status === "connecting" ? "Connecting" : "Offline"}
        </span>
        {onLeave ? (
          <button className="room-header__leave" type="button" onClick={onLeave}>
            <LogOut aria-hidden="true" /> Leave room
          </button>
        ) : null}
      </div>
    </header>
  );
}
